import { Component, ElementRef, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import {HelperService} from "../../service/helper.service";
import {ApiService} from "../../service/api.service";
import {TranslateConfigService} from "../../service/translate-config.service";

@Component({
    selector: 'app-tkp',
    templateUrl: './tkp.component.html',
    styleUrls: ['./tkp.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class TkpComponent implements OnInit, OnDestroy {
    @ViewChild('tkpTXCB', { static: false }) elTkpTXCB: ElementRef;
    issue: number;
    issueStoreLatest: number;
    dateIssue = '';
    diceFirst = 1;
    diceSecond = 1;
    diceThird = 1;
    totalDice = 0;
    getHisTai = [];
    getHisXiu = [];
    listHisPagiTai = [];
    totalBetTai = 0;
    totalRefundTai = 0;
    listHisPagiXiu = [];
    totalBetXiu = 0;
    totalRefundXiu = 0;
    numPagiTai = 1;
    numPagiXiu = 1;
    isResultTai = false;
    isResultXiu = false;
    subscriptionIsNextTKP: Subscription;
    subscriptionScreenOri: Subscription;
    isNextPhien = false;
    isLandscape = false;

    constructor(
        private modalCtr: ModalController,
        private navParams: NavParams,
        private hpService: HelperService,
        private apiService: ApiService,
        private screenOrientation: ScreenOrientation,
        public platform: Platform,
        private translateConfigService: TranslateConfigService
    ) {
        this.listTKPhien(navParams.data.dataTKP);
        this.issue = this.issueStoreLatest = navParams.data.txID;
        this.subscriptionIsNextTKP = this.hpService.getObserverIsValidNextTKPTXCB().subscribe(data => {
            if (data === 'checkNextTKPhien') {
                this.isNextPhien = true;
            } else if (data.hasOwnProperty('flag') && data['flag'] === 'reloadTkP') {
                this.issue = this.issueStoreLatest = data['issueNew'];
                this.getDataTKPhien();
            }
        });
        platform.ready().then((readySource) => {
            this.detectScreenOrient();
        });
        this.subscriptionScreenOri = screenOrientation.onChange().subscribe(
            () => {
                this.detectScreenOrient();
            }
        );
    }

    detectScreenOrient() {
        setTimeout(() => {
            const pH = this.platform.height();
            const pW = this.platform.width();
            let hGame = 0;
            if (pW > pH) {
                this.isLandscape = true;
                hGame = 305;
            } else if (pW < pH) {
                this.isLandscape = false;
                hGame = 490;
            }

            if (pH < hGame) {
                this.elTkpTXCB.nativeElement.style.transform = `scale(${(pH / hGame)})`;
            } else {
                this.elTkpTXCB.nativeElement.style.transform = `scale(1)`;
            }
        }, 100);
    }

    ngOnInit() {
    }

    ngOnDestroy(): void {
        this.subscriptionIsNextTKP.unsubscribe();
        this.subscriptionScreenOri.unsubscribe();
    }

    listTKPhien(dataObjHis) {
        let dataHis = dataObjHis['lstData'];
        // tslint:disable-next-line:no-eval
        const getResult = eval(dataObjHis['result']);
        this.diceFirst = getResult[0];
        this.diceSecond = getResult[1];
        this.diceThird = getResult[2];
        this.totalDice = this.diceFirst + this.diceSecond + this.diceThird;

        // check dice total show result Tai or Xiu
        if (this.totalDice <= 10) {
            this.isResultTai = false;
            this.isResultXiu = true;
        } else {
            this.isResultTai = true;
            this.isResultXiu = false;
        }
        if (dataHis.length <= 0) {
            this.hpService.observableAlertMiniGame.next({ msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-no-data')});
            this.listHisPagiTai = [];
            this.listHisPagiXiu = [];
            this.totalBetTai = 0;
            this.totalRefundTai = 0;
            this.totalBetXiu = 0;
            this.totalRefundXiu = 0;
            return;
        }
        this.numPagiTai = this.numPagiXiu = 1;
        dataHis = dataHis.map(item => {
            // tslint:disable-next-line:no-eval
            item['result'] = eval(item['result']);
            item['betamountC'] = this.hpService.convertMoneyTxt(item['betamount']);
            item['refundamountC'] = this.hpService.convertMoneyTxt(item['refundamount']);
            const betTimeItem = new Date(item['bettime']);
            item['time'] = this.hpService.getDateTimeHH_MM_SS(betTimeItem);
            return item;
        });
        const betTime = new Date(dataHis[0]['bettime']);
        this.dateIssue = this.hpService.getDateTimeByFormat(betTime, 'DD/MM/YYYY');

        this.getHisTai = dataHis.filter(item => item['typed'] === 1);
        this.totalBetTai = this.getHisTai.reduce((prevVal, { betamount }) => prevVal + betamount, 0);
        this.totalRefundTai = this.getHisTai.reduce((prevVal, { refundamount }) => prevVal + refundamount, 0);
        this.listHisPagiTai = this.getHisTai.slice(0, 5);

        this.getHisXiu = dataHis.filter(item => item['typed'] === 2);
        this.totalBetXiu = this.getHisXiu.reduce((prevVal, { betamount }) => prevVal + betamount, 0);
        this.totalRefundXiu = this.getHisXiu.reduce((prevVal, { refundamount }) => prevVal + refundamount, 0);
        this.listHisPagiXiu = this.getHisXiu.slice(0, 5);
    }

    async closeModal() {
        await this.modalCtr.dismiss();
    }

    prevListTai() {
        if (this.numPagiTai <= 1) {
            return;
        }
        this.numPagiTai -= 1;
        this.listHisPagiTai = this.getHisTai.slice((this.numPagiTai - 1) * 5, this.numPagiTai * 5);
    }

    nextListTai() {
        const getPagi = Math.ceil(this.getHisTai.length / 5);
        if (this.numPagiTai >= getPagi) {
            return;
        }
        this.listHisPagiTai = this.getHisTai.slice(this.numPagiTai * 5, 5 * (this.numPagiTai + 1));
        this.numPagiTai += 1;
    }

    prevListXiu() {
        if (this.numPagiXiu <= 1) {
            return;
        }
        this.numPagiXiu -= 1;
        this.listHisPagiXiu = this.getHisXiu.slice((this.numPagiXiu - 1) * 5, this.numPagiXiu * 5);
    }

    nextListXiu() {
        const getPagi = Math.ceil(this.getHisXiu.length / 5);
        if (this.numPagiXiu >= getPagi) {
            return;
        }
        this.listHisPagiXiu = this.getHisXiu.slice(this.numPagiXiu * 5, 5 * (this.numPagiXiu + 1));
        this.numPagiXiu += 1;
    }

    nextIssue() {
        if (this.isNextPhien && this.issueStoreLatest === this.issue) {
            this.hpService.observableAlertMiniGame.next({ msg: this.translateConfigService.getTranslateService().instant('MINI-GAME.msg-turn-not-over') });
        } else {
            this.issue += 1;
            this.getDataTKPhien();
        }
    }

    prevIssue() {
        this.issue -= 1;
        this.getDataTKPhien();
    }

    getDataTKPhien() {

        this.hpService.observableLoading.next(true);
        this.apiService.thongKePhienTX(this.issue).subscribe(
            data => {
                this.hpService.observableLoading.next(false);
                this.listTKPhien(data);
            },
            error => { console.log(error); },
            () => { }
        );
    }
}
